'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Host$() {
  this.c8A = null;
  this.c8B = false;
  this.c8y = null;
  this.c8z = false;
  this.c8E = null;
  this.c8F = false;
  this.c8C = null;
  this.c8D = false;
  this.c8I = null;
  this.c8G = null;
  this.c8H = false;
  $n_Lpresto_types$Host$ = this;
  this.c8I = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_s_util_matching_Regex__T__sci_Seq__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_matching_Regex(), "^(?=.{1,255}$)(?!-)[A-Za-z0-9-]{1,63}(?<!-)(\\.[A-Za-z0-9-]{1,63})*$", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
}
export { $c_Lpresto_types$Host$ as $c_Lpresto_types$Host$ };
$p = $c_Lpresto_types$Host$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Host$;
/** @constructor */
function $h_Lpresto_types$Host$() {
}
export { $h_Lpresto_types$Host$ as $h_Lpresto_types$Host$ };
$h_Lpresto_types$Host$.prototype = $p;
$p.csU = (function() {
  if ((!this.c8B)) {
    this.c8A = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c8B = true;
  }
  return this.c8A;
});
$p.vm = (function() {
  if ((!this.c8z)) {
    this.c8y = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.c8z = true;
  }
  return this.c8y;
});
$p.a3a = (function() {
  if ((!this.c8F)) {
    this.c8E = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c8F = true;
  }
  return this.c8E;
});
$p.aeb = (function() {
  if ((!this.c8D)) {
    this.c8C = new $c_Lpresto_types$Host$$anon$75(this);
    this.c8D = true;
  }
  return this.c8C;
});
$p.a3f = (function() {
  if ((!this.c8H)) {
    this.c8G = new $c_Lpresto_types$Host$$anon$76(this);
    this.c8H = true;
  }
  return this.c8G;
});
$p.a3t = (function(str) {
  return (((str.indexOf(".") | 0) !== (-1)) && this.c8I.aeQ(str));
});
var $d_Lpresto_types$Host$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Host$, "presto.types$Host$", ({
  a0A: 1,
  D: 1
}));
export { $d_Lpresto_types$Host$ as $d_Lpresto_types$Host$ };
var $n_Lpresto_types$Host$;
function $m_Lpresto_types$Host$() {
  if ((!$n_Lpresto_types$Host$)) {
    $n_Lpresto_types$Host$ = new $c_Lpresto_types$Host$();
  }
  return $n_Lpresto_types$Host$;
}
export { $m_Lpresto_types$Host$ as $m_Lpresto_types$Host$ };
/** @constructor */
function $c_Lpresto_types$Host$$anon$76(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$Host$$anon$76 as $c_Lpresto_types$Host$$anon$76 };
$p = $c_Lpresto_types$Host$$anon$76.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Host$$anon$76;
/** @constructor */
function $h_Lpresto_types$Host$$anon$76() {
}
export { $h_Lpresto_types$Host$$anon$76 as $h_Lpresto_types$Host$$anon$76 };
$h_Lpresto_types$Host$$anon$76.prototype = $p;
$p.bn = (function(it) {
  try {
    $m_Lpresto_types$Host$();
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(it);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a8 : e$2);
    }
  }
});
$p.bO = (function(text) {
  return ($m_Lpresto_types$Host$().a3t(text) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(text) : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), "Host inv\u00e1lido")));
});
$p.bK = (function(t) {
  return this.bn(t);
});
var $d_Lpresto_types$Host$$anon$76 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Host$$anon$76, "presto.types$Host$$anon$76", ({
  a0C: 1,
  K: 1
}));
export { $d_Lpresto_types$Host$$anon$76 as $d_Lpresto_types$Host$$anon$76 };
/** @constructor */
function $c_Lpresto_types$Host$$anon$75(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$Host$$anon$75 as $c_Lpresto_types$Host$$anon$75 };
$p = $c_Lpresto_types$Host$$anon$75.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Host$$anon$75;
/** @constructor */
function $h_Lpresto_types$Host$$anon$75() {
}
export { $h_Lpresto_types$Host$$anon$75 as $h_Lpresto_types$Host$$anon$75 };
$h_Lpresto_types$Host$$anon$75.prototype = $p;
$p.cD = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.cA = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.cs = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.ct = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.cK = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.cB = (function(other) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.b4 = (function(x, y) {
  $m_Lpresto_types$Host$();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__compareTo__T__I(x, y);
});
var $d_Lpresto_types$Host$$anon$75 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Host$$anon$75, "presto.types$Host$$anon$75", ({
  a0B: 1,
  O: 1,
  a: 1,
  Q: 1,
  U: 1,
  W: 1
}));
export { $d_Lpresto_types$Host$$anon$75 as $d_Lpresto_types$Host$$anon$75 };
//# sourceMappingURL=presto.types$-Host$.js.map
